import { useContext, useEffect, useState } from 'react';
import { useCouponPackLazyQuery } from '../../../../graphql/generated';
import { OrganizationContext } from '../../../../components/contexts/organization';
import { CouponPackDetailProps } from '../CouponPackDetail';

export type CouponPackDetailUseCase = CouponPackDetailProps;

export function useCouponPackDetail(couponPackId: string): CouponPackDetailUseCase {
  const orgContext = useContext(OrganizationContext);

  const [loading, setLoading] = useState(false);

  const [query, queryContext] = useCouponPackLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: () => {
      setLoading(false);
    },
  });
  const data = queryContext?.data;

  useEffect(() => {
    setLoading(true);
    query({
      variables: {
        couponPackId,
      },
    });
  }, [query]);

  return {
    loading: loading || orgContext.loading,
    data,
  };
}
